<template>
  <form name="step1">
    <div class="formStepTitle">
      Заполните контактную информацию <span>(шаг 1 из 4)</span>
    </div>
    <rangeTopLine></rangeTopLine>
    <range></range>
    <rangeBottomLine></rangeBottomLine>
    <p class="rangeScreenDesc">Сумма свыше <span>{{rangeMax | moneyFormat}}</span> <span class="rubl">a</span>
      доступна со второго
      займа
    </p>
    <div class="inputsCollection">
      <div class="inputs2">
        <fmInput
          :refs="'FIRST_NAME'"
        ></fmInput>
      </div>
      <div class="inputs2">
        <fmInput
          :refs="'LAST_NAME'"
        ></fmInput>
      </div>
    </div>
    <div class="inputs1">
      <fmInput
        :refs="'SECOND_NAME'"
      ></fmInput>
    </div>
    <div class="inputsCollection">
      <div class="inputs2">
        <fmInput
          :refs="'PHONE'"
        ></fmInput>
        <p class="info">На него позвонит наш менеджер</p>
      </div>


    </div>
    <div v-if="showResidentalAdressOnFrstStep">

        <fmSelectDadata :refs="'RESIDENTIAL_ADDRESS'"></fmSelectDadata>
      <p v-if="checkAdressResult==1" style="color:green">Адрес в зоне</p>
      <p v-if="checkAdressResult==2" style="color:red">Адрес не в зоне</p>
      <p v-if="checkAdressResult==3">Обработка</p>


      <button v-on:click.prevent="checkAdress">Проверить адрес</button>
    </div>
    <nxtButton v-on:submitStep="submitStep"></nxtButton>
  </form>
</template>

<script>
  import {mapState, mapGetters} from 'vuex';

  export default {
    name: "frstStep",
    data(){
      return{
        refsStepArr:[
          'PHONE',
          'EMAIL',
        ],
        checkAdressResult:0,
      }
    },
    components: {
      range: () => import('@/components/chunk/range'),
      rangeTopLine: () => import('@/components/chunk/rangeTopLine'),
      rangeBottomLine: () => import('@/components/chunk/rangeBottomLine'),
      fmInput: () => import('@/components/form/fmInput'),
      nxtButton: () => import('@/components/form/nextButton'),
      fmSelectDadata: () => import('@/components/form/fmSelectDadata'),
    },
    computed: {
      ...mapState({
        rangeMax: state => state.Deal.MaxSumm,
        statusVuex: state => state.Form.workData,
        valueVuex: state => state.Form.sendData,
        phoneVuex: state => state.Form.sendData.PHONE,
      }),
      ...mapGetters(['showResidentalAdressOnFrstStep']),
    },
    mounted(){
      this.$store.dispatch('hideLoading');
    },
    methods:{
      checkAdress(){
        this.checkAdressResult = 3;//загрузка
        if (this.statusVuex['RESIDENTIAL_ADDRESS'].code != 0) {
          this.$store.dispatch('errorShow', {
            target: 'RESIDENTIAL_ADDRESS',
            value: true,
          });
          return false;
        }
        this.$myApi.SendRequest({
          action:'GetAddressTerritory',

          Address:this.valueVuex.RESIDENTIAL_ADDRESS,

        }).then((res)=>{
          res['a'] = 'a';
          this.checkAdressResult = 1;//true
        }).catch((res)=>{
          res['a'] = 'a';
          this.checkAdressResult = 2;//false
        })
      },
      checkFormFieldValue(){
        //проверяем заполнения полей
        let isFormFieldCorrect = true;
        this.refsStepArr.forEach(item => {
          if (this.statusVuex[item].code != 0) {
            this.$store.dispatch('errorShow', {
              target: item,
              value: true,
            });
            isFormFieldCorrect = false;
          }
        });
        return isFormFieldCorrect;
      },
      submitStep(){
        this.$store.dispatch('showLoading');
        if (this.checkFormFieldValue()){
          this.$myApi.singleRequest({
            action:'AddShortRequest',
            data:{
              'PHONE':this.phoneVuex,
              'PRODUCT_ID':this.valueVuex['PRODUCT_ID'],
              'CALC_SUMM':this.valueVuex['CALC_SUMM'],
              'CALC_WEEK':this.valueVuex['CALC_WEEK'],
            },
          });
          if (window.ym) {
            // eslint-disable-next-line no-undef
            ym(51632228, 'reachGoal', 'admdFrstStep');
          }
          if (window.ga){
            // eslint-disable-next-line no-undef
            ga('send', 'event', 'admdForm', 'admdFrstStep');
          }
          this.$store.dispatch('formRouting','confirmSms');
        } else {
          window.dblClick = false;
          this.$store.dispatch('hideLoading');
        }
      }
    }
  }
</script>

<style scoped>

  /deep/ .fmRange .fmRangeBar {background: #97B0A9;}
  .rangeScreenDesc {font-size: 4.4vw;text-align: center;padding: 3.2vw 0 4.7vw;}
  .rangeScreenDesc span {font-weight: bold;}



  @media screen and (min-width: 760px) {
    .rangeScreenDesc {font-size: 1.3vw;text-align: left;padding: 0.9vw 0 1.4vw;}

  }
  @media screen and (min-width: 1140px) {
    .rangeScreenDesc { padding: 10px 0 15px;font-size: 14px;}


  }
</style>
